var _rect, _rect2, _g, _path, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 346,
    viewBox: "0 0 508 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 508,
    height: 346,
    rx: 16,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1599_10580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 55,
    width: 321,
    height: 291
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 55,
    width: 321,
    height: 291,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1599_10580)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1599_10580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.139,
    y: 55,
    width: 245.641,
    height: 389.113,
    rx: 42,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.639,
    y: 61.5,
    width: 232.641,
    height: 376.113,
    rx: 35.5,
    stroke: "#2B2B2B",
    strokeWidth: 13
  })), /*#__PURE__*/React.createElement("rect", {
    x: 207.134,
    y: 55,
    width: 93.6505,
    height: 26.1459,
    rx: 13,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1599_10580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.212,
    y: 68.0723,
    width: 21.4936,
    height: 4.61399,
    rx: 2.307,
    fill: "#666666"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.02 127.758V143.438H237.645V127.758H241.02ZM222.762 137.906C226.5 136.699 227.871 133.758 227.871 130.992V128.93H231.387V130.992C231.363 133.699 232.664 136.43 236.309 137.555L234.598 140.203C232.195 139.43 230.578 137.93 229.641 135.996C228.68 138.082 227.016 139.746 224.52 140.555L222.762 137.906ZM226.441 148.898V141.891H229.863V146.203H241.559V148.898H226.441ZM255.973 129.867V132.516H251.812C251.906 134.52 253.324 136.617 256.77 137.484L255.199 140.062C252.797 139.477 251.156 138.211 250.172 136.582C249.234 138.457 247.57 139.934 245.051 140.625L243.48 138C246.926 137.051 248.344 134.754 248.426 132.516H244.277V129.867H248.426V127.664H251.824V129.867H255.973ZM247.043 145.102C247.043 142.488 249.902 141.035 254.473 141.023C259.102 141.035 261.961 142.488 261.973 145.102C261.961 147.738 259.102 149.273 254.473 149.25C249.902 149.273 247.043 147.738 247.043 145.102ZM250.395 145.102C250.395 146.168 251.789 146.707 254.473 146.719C257.262 146.707 258.598 146.168 258.621 145.102C258.598 144.059 257.262 143.578 254.473 143.602C251.789 143.578 250.395 144.059 250.395 145.102ZM255.34 136.078V133.383H258.551V127.734H261.902V140.742H258.551V136.078H255.34ZM272.754 132.305C272.754 136.406 274.102 140.344 277.816 141.914L275.777 144.609C273.434 143.496 271.922 141.504 271.043 139.008C270.141 141.668 268.57 143.824 266.145 145.008L264.035 142.242C267.891 140.543 269.309 136.383 269.332 132.305V129.328H272.754V132.305ZM275.402 137.039V134.32H279.34V127.734H282.668V149.297H279.34V137.039H275.402Z",
    fill: "#2B2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 199.5,
    r: 18.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 187,
    width: 121,
    height: 7,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 203,
    width: 95,
    height: 7,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 250.5,
    r: 18.5,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 238,
    width: 121,
    height: 7,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 254,
    width: 95,
    height: 7,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 301.5,
    r: 18.5,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 289,
    width: 121,
    height: 7,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 305,
    width: 95,
    height: 7,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1599_10580",
    x: 127.139,
    y: 55,
    width: 253.641,
    height: 397.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1599_10580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1599_10580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1599_10580",
    x: 243.212,
    y: 68.0723,
    width: 22.4937,
    height: 5.61328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1599_10580"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction2);
export default __webpack_public_path__ + "static/media/ImgIntroduction2.b2463f49360813161f06728092bb7370.svg";
export { ForwardRef as ReactComponent };